import * as React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

interface HeaderProps {
  title: string;
}


export default function Header(props: HeaderProps) {
  const { title } = props;

  //TODO: 対応するセクションに置き換える。後はデザイン
  const sections = [
    { title: '当ブログについて', url: 'https://isyukan.com/blog' },
    { title: '動画ランダム表示', url: 'https://isyukan.com/movie-search2' },
    { title: 'お問い合わせ', url: 'https://isyukan.com/contact' },
    { title: 'twitter', url: 'https://twitter.com/kanatsuki_isyu' },
  ];

  return (
    <React.Fragment>
      <Toolbar sx={{
        borderBottom: 1,
        borderColor: 'divider',
        background: "#fef4f4"
      }}>
        <Typography
          component="h2"
          variant="h4"
          color="#356859"
          align="center"
          fontWeight="700"
          noWrap
          sx={{ flex: 1 }}
        >
          {title}
        </Typography>
      </Toolbar>
      <Toolbar
        component="nav"
        variant="dense"
        sx={{
          justifyContent: 'space-between',
          overflowX: 'auto',
          background: "linear-gradient(#c10339 0%,#c15171 100%)",
          color: "#fafafa",
        }}
      >
        {sections.map((section, index) => (
          <Link
            key={index}
            color="inherit"
            noWrap
            variant="body2"
            target="_blank"
            rel="noopener noreferrer"
            href={section.url}
            sx={{ p: 1, flexShrink: 0 }}
          >
            {section.title}
          </Link>
        ))}
      </Toolbar>
    </React.Fragment>
  );
}
